module.exports = __webpack_public_path__ + "img/img_home_case_6.74d7ff81.png";